<div class="modal-header">
    <h5 class="mb-0">{{title | translate }} {{ (item?.id ? 'common.edit' : 'common.create') | translate }}</h5>
</div>
<div class="modal-body">
    <form class="k-form k-form-md" [formGroup]="form">
        <div class="mb-1 row">
            <div class="col-12 col-md-4 col-xl-4">
                <app-label controlName="name" class="col-form-label">{{ 'user.name' | translate }}</app-label>
            </div>
            <div class="col-12 col-md-8 col-xl-8">
                <input type="text" id="name" formControlName="name" class="form-control" />
                <app-field-error-message controlName="name"></app-field-error-message>
            </div>
        </div>
        <div class="mb-1 row">
            <div class="col-12 col-md-4 col-xl-4">
                <app-label controlName="email" class="col-form-label">{{ 'user.email' | translate }}</app-label>
            </div>
            <div class="col-12 col-md-8 col-xl-8">
                <input type="text" id="email" formControlName="email" class="form-control" />
                <app-field-error-message controlName="email"></app-field-error-message>
            </div>
        </div>
        <div class="mb-1 row">
            <div class="col-12 col-md-4 col-xl-4">
                <app-label controlName="role" class="col-form-label">{{ 'user.role' | translate }}</app-label>
            </div>
            <div class="col-12 col-md-8 col-xl-8">
                <select class="form-control form-select" id="role" formControlName="role">
                    <option value="">{{ 'common.please_select' | translate }}</option>
                    <option *ngFor="let r of roles" [ngValue]="r.text">
                        {{ r.text }}
                    </option>
                </select>
                <app-field-error-message controlName="role"></app-field-error-message>
            </div>
        </div>
        <div class="mb-1 row" *ngIf="isPartnerRoleSelected">
            <div class="col-12 col-md-4 col-xl-4">
                <app-label controlName="partnerId" class="col-form-label">{{ 'user.partner' | translate }}</app-label>
            </div>
            <div class="col-12 col-md-8 col-xl-8">
                <select class="form-control form-select" id="partner" formControlName="partnerId">
                    <option value="">{{ 'common.please_select' | translate }}</option>
                    <option *ngFor="let partner of partners" [value]="partner.value">
                        {{ partner.text }}
                    </option>
                </select>
                <app-field-error-message controlName="partnerId"></app-field-error-message>
            </div>
        </div>
        <div class="mb-1 row">
            <div class="col-12 col-md-4 col-xl-4">
                <app-label controlName="isActive" class="col-form-label">{{ 'user.is_active' | translate }}</app-label>
            </div>
            <div class="col-12 col-md-8 col-xl-8">
                <div class="form-check col-form-label">
                    <input type="checkbox" id="isActive" formControlName="isActive" class="form-check-input" />
                    <app-field-error-message controlName="isActive"></app-field-error-message>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="submit" [appClickWait]="onSave" class="btn btn-primary" themeColor="primary">
        {{ 'common.save' | translate }}</button>
    <button class="btn btn-secondary" (click)="onClose()">{{ 'common.cancel' | translate }}</button>
</div>
